@if (years) {
  <div class="mb-2 flex gap-3 align-items-center">
    @if (label) {
      <label class="flex gap-2 align-items-center"
        ><i class="fas fa-calendar-days"></i> {{ label }}</label
      >
    }
    <ng-container
      *ngTemplateOutlet="
        groupToggle;
        context: { $implicit: nonForecastYearsList }
      "></ng-container>
  </div>
  <div class="flex flex-column flex-wrap gap-1 h-10rem">
    @for (year of nonForecastYearsList; track $index) {
      <p-checkbox
        [ngModel]="isInverseSelected(year)"
        [ngModelOptions]="{ standalone: isStandalone }"
        [binary]="true"
        (ngModelChange)="toggleSelection(year, $event)"
        [label]="year + ''"
        [name]="name"
        [value]="year" />
    }
  </div>
  @if (forecastYearsList.length > 0) {
    <div
      class="forecast-year-heading mt-2 mb-1 flex align-items-center gap-2">
      <span><i class="fas fa-gauge mr-1"></i>Prognosejahre</span>
      <ng-container
        *ngTemplateOutlet="
          groupToggle;
          context: { $implicit: forecastYearsList }
        "></ng-container>
    </div>
    <div class="flex flex-wrap gap-3">
      @for (year of forecastYearsList; track $index) {
        <p-checkbox
          [ngModel]="isInverseSelected(year)"
          [ngModelOptions]="{ standalone: isStandalone }"
          [binary]="true"
          (ngModelChange)="toggleSelection(year, $event)"
          [label]="year + ''"
          [name]="name"
          [value]="year" />
      }
    </div>
  }
}

<!-- One show/hide-all toggle per group, so switching all actual years on
     doesn't silently switch the forecast years on too. -->
<ng-template #groupToggle let-groupYears>
  <p-button
    class="ml-auto"
    styleClass="w-auto"
    severity="secondary"
    size="small"
    [rounded]="true"
    [text]="true"
    [raised]="true"
    [disabled]="!groupYears.length"
    [icon]="
      areAllVisible(groupYears) ? 'fa-regular fa-circle' : 'fas fa-check-circle'
    "
    [label]="areAllVisible(groupYears) ? 'alle abwählen' : 'alle auswählen'"
    (click)="toggleGroup(groupYears)"></p-button>
</ng-template>
